import { type Theme } from '#app/theme/index.js';
import { type AvatarSize } from '../Avatar/types.js';
import { getAvatarSize } from '../Avatar/utils.js';
import { css, styled } from 'styled-components';

const MAX_DISPLAY_COUNT = 99;

const getFontSize = (size: AvatarSize): number => {
  if (typeof size === 'number') {
    if (size <= 32) return 12;

    return 14;
  }

  switch (size) {
    case 'sm': {
      return 12;
    }

    default: {
      return 14;
    }
  }
};

const MoreButton = styled.button<{
  borderColor: keyof Theme['colors'] | string;
  onClick?: () => void;
  size: AvatarSize;
}>`
  ${({ onClick, size, theme }) => css`
    display: block;
    background: ${theme.colorsV2.gray10};
    color: ${theme.colorsV2.gray70};
    cursor: ${onClick ? 'pointer' : 'default'};
    font-size: ${getFontSize(size)}px;
    font-weight: 500;
    border-radius: 50%;
    padding: 0;
    text-align: center;
    height: ${getAvatarSize(size)}px;
    width: ${getAvatarSize(size)}px;
  `}
`;

type MoreIndicatorProps = {
  readonly borderColor?: keyof Theme['colors'] | string;
  /**
   * The total number of excess avatars
   */
  readonly count: number;
  readonly onClick?: () => void;
  readonly size: AvatarSize;
};

export const MoreIndicator = ({
  borderColor = 'brandWhite',
  count,
  onClick,
  size,
}: MoreIndicatorProps) => {
  return (
    <MoreButton
      borderColor={borderColor}
      onClick={onClick}
      size={size}
    >
      +{count > MAX_DISPLAY_COUNT ? MAX_DISPLAY_COUNT : count}
    </MoreButton>
  );
};
